module.exports = __webpack_public_path__ + "f8e36a49df6595ed57ccbb4c6a1d9f00.svg";